interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  name: string;
  type: string;
  id: string;
  required: boolean;
  htmlFor: string;
  value?: string;
  disable?: boolean;
  placeholder?: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const RegisterInput = (props: InputProps) => {
  const {
    label,
    name,
    type,
    id,
    required,
    htmlFor,
    value,
    disable,
    placeholder,
    handleChange,
    ...rest
  } = props;
  return (
    <div>
      <label
        htmlFor={htmlFor}
        className="block mt-1 text-sm font-medium text-gray-900 dark:text-white"
      >
        {label} {required && <span className="ml-1 text-[red]">*</span>}
      </label>
      <input
        name={name}
        type={type}
        id={id}
        value={value}
        disabled={disable}
        placeholder={placeholder}
        className={`${
          disable && "bg-slate-100"
        }bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-4 focus:ring-blue-300 focus:border-blue-300 block w-full p-2.5 outline-none`}
        onChange={handleChange}
        {...rest}
      />
    </div>
  );
};

export default RegisterInput;
